module.exports = __webpack_public_path__ + "static/media/Layout12.e18b0d4f.png";